"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Twitter, Instagram, Youtube, Mail, Phone, MapPin } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="/HomePage" className="text-muted-foreground hover:text-primary transition-colors font-mono">Home</Link>
        </li>
        <li data-index={1}>
          <Link to="/SupportHubPage" className="text-muted-foreground hover:text-primary transition-colors font-mono">Support Hub</Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors font-mono">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
const socialLinks = [{
  icon: Facebook,
  href: "#",
  label: "Facebook"
}, {
  icon: Twitter,
  href: "#",
  label: "Twitter"
}, {
  icon: Instagram,
  href: "#",
  label: "Instagram"
}, {
  icon: Youtube,
  href: "#",
  label: "Youtube"
}];
const careGuides = [{
  label: "Service Tiers",
  path: "/ServiceTiersPage"
}, {
  label: "Efficiency Metrics",
  path: "#"
}, {
  label: "Case Resolution",
  path: "#"
}];
export default function Footer() {
  return <section data-section-id="264936" id="footer" className="bg-background border-t border-border/10 pt-16 pb-8 text-sm font-sans text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <WvcLogo className="h-8 w-auto text-primary" />
            </Link>
            <p className="text-muted-foreground mb-6 leading-relaxed font-default">
              AI Tech Solutions provides autonomous support agents that outperform human IT teams. Solve complex cases with maximum efficiency and minimal operational overhead.
            </p>
            <div className="flex gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} to={social.href} aria-label={social.label} className="text-muted-foreground hover:text-primary transition-all duration-300 hover:scale-110 hover:drop-shadow-[0_0_8px_rgba(0,255,255,0.5)]" data-index={i}>
                    <Icon className="size-5" />
                  </Link>;
            })}
            </div>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-base mb-6 text-foreground tracking-tight uppercase">Navigation</h3>
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-base mb-6 text-foreground tracking-tight uppercase">Solutions</h3>
            <ul className="space-y-3">
              {careGuides.map((guide, i) => <li key={i} data-index={i}>
                  <Link to={guide.path} className="text-muted-foreground hover:text-primary transition-colors font-mono">
                    {guide.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-base mb-6 text-foreground tracking-tight uppercase">Contact Us</h3>
            <ul className="space-y-4 mb-8">
              <li className="flex items-start gap-3 text-muted-foreground font-mono" data-index={0}>
                <MapPin className="size-4 mt-0.5 shrink-0 text-primary" />
                <span>155 Princess St. Kangaroo Point, QLD, 4169 Australia</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground font-mono" data-index={1}>
                <Phone className="size-4 shrink-0 text-primary" />
                <span>0468075702</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground font-mono" data-index={2}>
                <Mail className="size-4 shrink-0 text-primary" />
                <span>info@aitechsolution.io</span>
              </li>
            </ul>
            
            <h3 className="font-default font-bold text-base mb-4 text-foreground tracking-tight uppercase">Legal</h3>
            <ul className="space-y-3 flex flex-col">
              <li data-index={0}>
                <Link to="#" className="text-muted-foreground hover:text-primary transition-colors font-mono">Privacy Policy</Link>
              </li>
              <li data-index={1}>
                <Link to="#" className="text-muted-foreground hover:text-primary transition-colors font-mono">Terms of Service</Link>
              </li>
            </ul>
          </div>

        </div>

        {}
        <div className="mt-16 pt-8 border-t border-border/10 flex flex-col md:flex-row justify-between items-center gap-4 text-muted-foreground">
          <p className="font-mono text-xs">© {new Date().getFullYear()} AI Tech Solutions. All rights reserved.</p>
          <p className="text-xs font-mono uppercase tracking-widest">Engineered for the autonomous future.</p>
        </div>
      </div>
    </section>;
}